import React, { useEffect, useState } from "react";

const OfflineIndicator = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOnlineMsg, setShowOnlineMsg] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowOnlineMsg(true);
      setTimeout(() => {
        setShowOnlineMsg(false);
      }, 4000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowOnlineMsg(false); // hide online msg if going offline again
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!isOnline) {
    return <div style={offlineStyle}>⚠️ You are offline. Changes may not be saved.</div>;
  }

  if (isOnline && showOnlineMsg) {
    return <div style={onlineStyle}>✅ You are back online!</div>;
  }

  return null;
};

const baseStyle = {
  position: "fixed",
  bottom: "20px",
  right: "20px",
  color: "#fff",
  textAlign: "center",
  padding: "10px 16px",
  borderRadius: "8px",
  zIndex: 9999,
  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
};

const offlineStyle = {
  ...baseStyle,
  backgroundColor: "#ff4d4f",
};

const onlineStyle = {
  ...baseStyle,
  backgroundColor: "#52c41a",
};

export default OfflineIndicator;
